.root {
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 640px;
  width: 100%;
}

.header {
  display: flex;
  flex-direction: column;
  gap: 8px;
}


.fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.actions {
  display: flex;
  gap: 16px;
  padding: 8px 0;

  > button {
    flex: 1;
  }
}
